import React, { useState, useEffect, useRef } from "react";
import { useLanguage } from "../context/LanguageContext";

function SkillCard({ title, items, delay }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className="skill-card"
      style={{
        opacity: visible ? 1 : 0,
        transform: `translateY(${visible ? 0 : 30}px)`,
        transitionDelay: `${delay}ms`,
      }}
    >
      <div className="skill-card-title">
        <span className="dot-indicator" />
        {title}
      </div>
      <div className="skill-tags">
        {items.map((item) => (
          <span key={item} className="skill-tag">{item}</span>
        ))}
      </div>
    </div>
  );
}

function Skills() {
  const { t } = useLanguage();
  const headerRef = useRef(null);
  const [headerVisible, setHeaderVisible] = useState(false);

  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setHeaderVisible(true); obs.disconnect(); } },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const categories = [
    { key: "catLanguages", items: ["Java", "Python", "PHP", "JavaScript", "HTML5", "CSS3", "Dart"] },
    { key: "catFrontend", items: ["React", "Material-UI", "Bootstrap"] },
    { key: "catBackend", items: ["Laravel", "Express.js", "Spring", "Node.js"] },
    { key: "catMobile", items: ["Flutter", "Android", "Ionic", "React Native"] },
    { key: "catDatabase", items: ["MySQL", "PostgreSQL", "MongoDB", "Firebase"] },
    { key: "catCloud", items: ["Salesforce", "Mulesoft", "Google Cloud"] },
    { key: "catDevops", items: ["Azure DevOps", "Jenkins", "Docker"] },
    { key: "catVersioning", items: ["GitHub", "GitLab", "Azure"] },
    { key: "catDesign", items: ["Photoshop", "Illustrator", "Premiere Pro", "After Effects", "Figma", "Canva"] },
  ];

  return (
    <section className="skills-section" id="skills">
      <div className="skills-content">
        <div
          ref={headerRef}
          style={{
            textAlign: "center",
            marginBottom: 48,
            opacity: headerVisible ? 1 : 0,
            transform: `translateY(${headerVisible ? 0 : -20}px)`,
            transition: "all 0.8s cubic-bezier(0.16,1,0.3,1)",
          }}
        >
          <p className="section-eyebrow">{t("skillsEyebrow")}</p>
          <h2 className="section-title">
            {t("skillsTitle")}<span className="dot">.</span>
          </h2>
          <p className="section-subtitle">{t("skillsSubtitle")}</p>
          <div
            className="section-underline"
            style={{ width: headerVisible ? 80 : 0, margin: "14px auto 0" }}
          />
        </div>

        <div className="skills-grid">
          {categories.map((cat, i) => (
            <SkillCard key={cat.key} title={t(cat.key)} items={cat.items} delay={i * 70} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
